import classnames from "classnames/bind";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styles from "./index.css";
import { hideSortOverlay } from "../../state/modules/layout/actions";
import { getSortOverlayVisible } from "../../state/modules/layout/selectors";
import TrapFocus from "../../components/TrapFocus";
import Escapable from "../../components/Escapable";

const styleContext = classnames.bind(styles);

export const SortLayout = ({
  isSortOverlayVisible,
  hideSortOverlay,
  children
}) => {
  const layout = styleContext({
    filterLayout: true,
    showOnMobile: isSortOverlayVisible
  });

  const handleClick = () => {
    if (isSortOverlayVisible) {
      hideSortOverlay();
    }
  };

  return (
    <div className={styles.container}>
      <Escapable escapeHandler={handleClick} />
      <div className={layout}>
        <aside
          className={styles.grayTapArea}
          onClick={handleClick}
          aria-hidden={true}
        />
        <TrapFocus
          className={styles.filterContainer}
          trapFocus={isSortOverlayVisible}
        >
          {children}
        </TrapFocus>
      </div>
    </div>
  );
};

SortLayout.propTypes = {
  children: PropTypes.node.isRequired,
  hideSortOverlay: PropTypes.func.isRequired,
  analyticsRefinementsCloseMobile: PropTypes.func,
  isSortOverlayVisible: PropTypes.bool.isRequired
};

SortLayout.displayName = "SortLayout";

/* istanbul ignore next */
const mapDispatchToProps = {
  hideSortOverlay
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    isSortOverlayVisible: getSortOverlayVisible(state)
  };
}

const SortLayoutContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SortLayout);

export default SortLayoutContainer;
